var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex", attrs: { id: "super-admin-subscription-base" } },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "sticky top-0 z-50 h-10 flex items-center flex-shrink-0 border-b border-slate-400 bg-pure-white",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          [
            _c("BlBreadcrumbs", {
              staticClass: "sticky left-0 px-6",
              attrs: { breadcrumbs: _vm.breadcrumbs }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "py-6 flex justify-center" }, [
          _vm.pageLoading
            ? _c(
                "div",
                { staticClass: "w-full h-128 grid place-items-center" },
                [_c("div", { staticClass: "blum-loader" })]
              )
            : _vm.subscription
            ? _c(
                "div",
                { staticClass: "max-w-180 w-full flex flex-col gap-5" },
                [
                  _c(
                    "div",
                    { staticClass: "w-full bg-pure-white rounded-2xl" },
                    [
                      _c("div", { staticClass: "py-6 px-6" }, [
                        _c(
                          "div",
                          { staticClass: "flex items-center mb-4" },
                          [
                            _c("BlTextTitle4", {
                              attrs: { text: "Subscription details" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "grid grid-cols-6 gap-3" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-700",
                              attrs: { text: "Subscription name" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-4 text-slate-1000",
                              attrs: { text: _vm.subscription.name }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-700",
                              attrs: { text: "Status" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex col-span-4" },
                              [
                                _c("BlChip", {
                                  attrs: {
                                    chip: _vm.subscription.status,
                                    dense: ""
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-700",
                              attrs: { text: "Subscription start date" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-4 text-slate-1000",
                              attrs: {
                                text: _vm.displayDate({
                                  date: _vm.subscription.start_date
                                })
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-700",
                              attrs: { text: "Subscription expiry date" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-4 text-slate-1000",
                              attrs: {
                                text: _vm.displayDate({
                                  date: _vm.subscription.expiration_date
                                })
                              }
                            }),
                            _vm._v(" "),
                            _vm.subscription.type === "Subscription::Custom"
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-700",
                                  attrs: { text: "Total amount due" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subscription.type === "Subscription::Custom"
                              ? _c(
                                  "div",
                                  { staticClass: "col-span-4 flex gap-1" },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-1000",
                                      attrs: {
                                        text: _vm.subscription.currency_sym
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-1000",
                                      attrs: {
                                        text: _vm.priceFormats(
                                          _vm.subscription.amount
                                        )
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-700",
                              attrs: { text: "Number of seats" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-4 text-slate-1000",
                              attrs: {
                                text:
                                  _vm.subscription.number_of_seats + " seat(s)"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-700",
                              attrs: { text: "Notes" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass:
                                "col-span-4 text-slate-1000 whitespace-pre-line",
                              attrs: { text: _vm.subscription.notes || "-" }
                            }),
                            _vm._v(" "),
                            _vm.subscription.status === "inactive"
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-700",
                                  attrs: {
                                    text: "Subscription cancellation date"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subscription.status === "inactive"
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-4 text-slate-1000",
                                  attrs: {
                                    text: _vm.displayDate({
                                      date: _vm.subscription.cancelled_at,
                                      format: "DD/MM/YYYY"
                                    })
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subscription.status === "inactive"
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-700",
                                  attrs: { text: "Cancelled by" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subscription.status === "inactive"
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-4 text-slate-1000",
                                  attrs: {
                                    text:
                                      (_vm.subscription.cancellation_user &&
                                        _vm.subscription.cancellation_user
                                          .name) ||
                                      "-"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subscription.status === "inactive"
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-700",
                                  attrs: { text: "Cancellation notes" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subscription.status === "inactive"
                              ? _c("BlTextBody2", {
                                  staticClass:
                                    "col-span-4 text-slate-1000 whitespace-pre-line",
                                  attrs: {
                                    text:
                                      _vm.subscription.cancellation_reason ||
                                      "-"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "py-4 px-6 flex items-center justify-between border-t border-slate-400"
                        },
                        [
                          _c("BlInputButton", {
                            attrs: {
                              type: "outlined-error",
                              label:
                                _vm.subscription.status === "inactive"
                                  ? "Subscription cancelled"
                                  : "Cancel subscription",
                              disabled: _vm.subscription.status === "inactive"
                            },
                            on: {
                              clicked: function($event) {
                                _vm.cancelOpened = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-4" },
                            [
                              _c("BlInputButton", {
                                attrs: {
                                  type: "outlined",
                                  label: "Edit subscription"
                                },
                                on: {
                                  clicked: function($event) {
                                    _vm.editOpened = true
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.editOpened
        ? _c("EditSubscriptionModal", {
            attrs: { subscription: _vm.subscription },
            on: {
              "close-modal": function($event) {
                _vm.editOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Cancel subscription",
                label: "Cancel subscription",
                submitLoading: _vm.submitLoading,
                maxWidth: "40rem"
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.cancelOpened = false
                },
                "backdrop-action": _vm.onCancel
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-8 flex flex-col gap-4" },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text: "You are about to cancel the subscription for"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: "" + _vm.subscription.name }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { text: "By canceling the subscription," }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: "the center will be deactivated immediately,"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "and all users will no longer be able to access the center."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.cancellationReason },
                    on: { changed: _vm.inputHandler }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70bc67f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70bc67f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/center/subscription/Subscription.vue
// module id = null
// module chunks = 